<header>
  <mat-toolbar class="hmn-toolbar">
    <mat-toolbar-row class="hmn-row__space">
      <div class="hmn-row__align">
        <app-toolbar-scope></app-toolbar-scope>
        <app-toolbar-navigation class="hmn-hidden__before-lg"></app-toolbar-navigation>
      </div>

      <div class="hmn-row__align">
        <app-toolbar-profile></app-toolbar-profile>
        <app-toolbar-menu></app-toolbar-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
